import React from "react";
import AppBar2 from "../../appbar/AppBar2";
import BottomNav from "../BottomNav";

const MainLayout = ({ children, hideFooter, hideLogoHeader }) => {
  return (
    <div>
      {!hideLogoHeader && <AppBar2 />}
      <main className={!hideLogoHeader ? "mt-[60px]" : ""}>{children}</main>
      {!hideFooter && <BottomNav />}
    </div>
  );
};

export default MainLayout;
